import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { Helmet } from "react-helmet-async";
import SEO from "@/components/SEO";

const KontoLoeschen = () => {
  return (
    <div className="min-h-screen bg-background">
      <Helmet>
        <title>Konto löschen – MusiKonzept</title>
        <meta name="description" content="Informationen zur Löschung deines MusiKonzept-Kontos und deiner persönlichen Daten." />
      </Helmet>
      <SEO title={`Konto löschen | MusiKonzept`} description={`So löschst du dein MusiKonzept-Konto und alle persönlichen Daten – Schritt-für-Schritt-Anleitung und Bearbeitungszeit.`} path="/konto-loeschen" />
      <Header />
      <main className="pt-32 pb-20">
        <div className="container mx-auto px-6">
          <div className="max-w-3xl mx-auto">
            <h1 className="text-3xl md:text-4xl font-bold mb-8">Konto löschen</h1>

            <div className="space-y-8 text-foreground/90 leading-relaxed">
              <section>
                <h2 className="text-xl font-semibold mb-3">So löschst du dein Konto</h2>
                <p>
                  Wenn du dein MusiKonzept-Konto löschen möchtest, sende bitte eine E-Mail an{" "}
                  <a href="mailto:info@musikonzept.de" className="text-primary underline font-medium">
                    info@musikonzept.de
                  </a>{" "}
                  mit dem Betreff <strong>„Konto löschen"</strong>.
                </p>
                <p className="mt-2">
                  Bitte verwende die E-Mail-Adresse, mit der du dich bei MusiKonzept registriert hast, damit wir dein Konto eindeutig zuordnen können.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold mb-3">Welche Daten werden gelöscht?</h2>
                <ul className="list-disc pl-6 space-y-1">
                  <li>Dein Benutzerprofil (Name, E-Mail-Adresse, Profilbild)</li>
                  <li>Kursfortschritte und Lernstände</li>
                  <li>Community-Beiträge und Kommentare</li>
                  <li>Gespeicherte Notizen und Favoriten</li>
                  <li>Zertifikate und Prüfungsdaten</li>
                  <li>Chat-Verläufe</li>
                </ul>
              </section>

              <section>
                <h2 className="text-xl font-semibold mb-3">Wie lange dauert die Löschung?</h2>
                <p>
                  Wir löschen dein Konto und alle zugehörigen Daten innerhalb von <strong>7 Werktagen</strong> nach Eingang deiner Anfrage. Du erhältst eine Bestätigung per E-Mail, sobald die Löschung abgeschlossen ist.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold mb-3">Wichtige Hinweise</h2>
                <ul className="list-disc pl-6 space-y-1">
                  <li>Die Kontolöschung ist unwiderruflich. Alle Daten werden dauerhaft entfernt.</li>
                  <li>Ein aktives Abonnement wird zum Ende der laufenden Abrechnungsperiode gekündigt.</li>
                  <li>Bereits ausgestellte Zertifikate können nach der Löschung nicht erneut abgerufen werden.</li>
                </ul>
              </section>

              <section>
                <h2 className="text-xl font-semibold mb-3">Kontakt</h2>
                <p>
                  Bei Fragen zur Kontolöschung oder zum Datenschutz wende dich an:{" "}
                  <a href="mailto:info@musikonzept.de" className="text-primary underline font-medium">
                    info@musikonzept.de
                  </a>
                </p>
              </section>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default KontoLoeschen;
